import React from "react";
import useTranslation from "../i18n/useTranslation";

const AccessDenied = () => {
   const { t } = useTranslation();

   return (
      <div className="mt-6 mx-auto text-center">
         <div className="text-red-500">
            <h1>{t("auth.accessDeniedTitle")}</h1>
            <p>{t("auth.accessDeniedMessage")}</p>
         </div>
      </div>
   );
};

export default AccessDenied;
